import React from "react";
import { Component } from "react";
import DropzoneComponent from 'react-dropzone-component';
import Icons from '../../../icon';
import ButtonIcon from '../../../button';
import { NotificationModal } from "../../modal/notification-modal.component";
import { MODAL_CUSTOM_MESSAGE, MODAL_CUSTOM_TITLE, UPLOAD_TYPES } from "../../../../constants/external-constants";
import { apiEndPoint, GetAjaxHeaderTokenOnly } from "../../../../utils/api.utils";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../utils/rbac-constants.utils";
import { validateAccessModule } from "../../../../utils/helpers.utils";
import CustomDragDrop from "./custom-drag-drop.component"
import CustomDropdownButton from "../../custom-form/custom-dropdown-button.component";

class DragDropUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fileProgress: {},
            showErrorNotif: false,
            errorMessage: "",
            errorSubMessage: "",
            progressBarPercent: 0,
            showProgressBar: false,
            isUploading: false,
            showProcessNotif: false,
            isReadAndWrite: false
        }

        this.activeFilesCount = 0;
    }

    componentDidMount() {
        this.setState({
            isReadAndWrite: !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InvoiceInvoiceUploadDashboardRW])
        })
    }

    handleCloseNotif = () => {
        this.setState({
            showErrorNotif: false,
            showProcessNotif: false
        });
        this.props.onErrorUpload();
       
    }

    renderFileName = (name) =>{
        const filename = name;
        const extIndex = filename.lastIndexOf('.');
        const newName = filename.substring(0, Math.min(extIndex, 20));
        const extension = filename.substring(extIndex + 1);
        const finalName = extIndex > 20 ? `${newName}...${extension}` : filename;

        return finalName;
    }

    handleInit = (dropzone) => {
        this.dropzone = dropzone;
        this.dropzone.hiddenFileInput.disabled = true;
        this.dropzone.hiddenFileInput.multiple = true;

        this.registerDropzoneEvents();
    };

    registerDropzoneEvents = () => {
        const { onSuccessProcess, djsConfigParams } = this.props;
        var that = this;

        this.dropzone.on('uploadprogress', function (file, progress) {
            if (file.previewElement) {
                var progressElement = file.previewElement.querySelector("[data-dz-uploadprogress]");
                progressElement.style.width = progress + "%";
                progressElement.querySelector(".progress-text").textContent = Math.trunc(progress / 1.01) + "%";
            }
        });

        this.dropzone.on('successmultiple', function (files, res) {
            var arr = Object.values(files);
            if (res.Result) {
                arr.map(file => {
                    if (file.previewElement) {
                        var progress = 100;
                        var progressElement = file.previewElement.querySelector("[data-dz-uploadprogress]");
                        progressElement.style.width = progress + "%";
                        progressElement.querySelector(".progress-text").textContent = progress + "%";
                    }
                });
                that.setState({
                    showProcessNotif: true
                });
                that.removeFiles();
                onSuccessProcess(res);
            } else {
                arr.map(file => {
                    if (file.previewElement) {
                        var progress = 0;
                        var progressElement = file.previewElement.querySelector("[data-dz-uploadprogress]");
                        progressElement.style.width = progress + "%";
                        progressElement.querySelector(".progress-text").textContent = progress + "%";
                    }
                });

                that.setState({
                    showErrorNotif: true,
                    errorMessage: djsConfigParams.dictErrorOccured,
                    errorSubMessage: res.ResultMessage
                });

                that.dropzone.files.map(file => file.status = 'queued');
                that.removeFiles();
            }

            that.setState({
                isUploading: false,
            });

            that.dropzone.hiddenFileInput.disabled = false;
        });

        this.dropzone.on('error', function (file, message) {
            const { djsConfigParams } = that.props;

            if (djsConfigParams.maxFiles > 0) {
                that.setState({
                    showErrorNotif: true,
                    errorMessage: message,
                    errorSubMessage: ""
                });
            }

            setTimeout(() => {
                that.dropzone.removeAllFiles(true);
            }, 100);
        });
    }

    handleDelete = (file) => {
        this.dropzone.removeFile(file);
    }

    removeFiles = () => {
        if (this.state.isReadAndWrite) {
            this.dropzone.removeAllFiles();
        }
    }

    getDjsConfig = () => {
        var ReactDOMServer = require('react-dom/server');
        const { djsConfigParams } = this.props;

        const djsConfig = {
            ...djsConfigParams,
            headers: GetAjaxHeaderTokenOnly(),
            timeout: 0,
            autoProcessQueue: false,
            parallelUploads: 50,
            uploadMultiple: true,
            dictDefaultMessage: 'Drag and drop or <b class="purple">browse</b> your files',
            previewTemplate: ReactDOMServer.renderToStaticMarkup(
                <div className="dz-preview dz-file-preview file-detail">
                    <div className="file-container">
                        <Icons
                            customClassName="file-lines"
                            name="file-lines"
                            size="14px"
                            containerClass="file-lines-container"
                        />
                        <div className="dz-filename">
                            <span data-dz-name />
                        </div>
                        <i className="drop-upl-remove-file" data-dz-remove>
                            <Icons
                                customClassName="icon-trash"
                                name="trash-can"
                                size="14px"
                                containerClass="icon-trash-container"
                            />
                        </i>
                    </div>
                    <div className="progress">
                        <div className="progress-bar progress-bar-primary" role="progressbar" data-dz-uploadprogress>
                            <span className="progress-text"></span>
                        </div>
                    </div>
                    <div className="dz-filesize">
                        <span className="file-size" data-dz-size />
                    </div>
                </div>
            ),
            previewsContainer: '.dropzone-previews'
        }

        return djsConfig;
    }

    handleAddedFile = (files) => {
        if (files.previewElement) {
            var progressElement = files.previewElement.querySelector("[data-dz-name]");
            progressElement.textContent = this.renderFileName(files.name);
        };
        this.activeFilesCount += 1;

        const { onAddFiles } = this.props;
        onAddFiles();
    }

    handleRemovedFile = (files) => {
        if (files instanceof File) {
            this.activeFilesCount -= 1;
        }
        else if (files instanceof FileList) {
            var arr = Object.values(files);
            this.activeFilesCount -= arr.length;
        }

        const { onRemoveFiles } = this.props;
        onRemoveFiles();
    }

    checkValidFileForm = () => {
        const { djsConfigParams } = this.props;

        var isValid = (djsConfigParams.maxFiles != 0 && djsConfigParams.minFiles != 0) && (djsConfigParams.maxFiles >= this.activeFilesCount && djsConfigParams.minFiles <= this.activeFilesCount);
        return isValid;
    }

    getEventHandlers = () => {
        const eventHandlers = {
            init: this.handleInit.bind(this),
            addedfile: this.handleAddedFile.bind(this),
            removedfile: this.handleRemovedFile.bind(this)
        };

        return eventHandlers;
    }

    getComponentConfig = (uploadTypeId) => {
        var componentConfig;
        const uploadTypes = [UPLOAD_TYPES.ChargeTypeUpload, UPLOAD_TYPES.RateCardUpload, UPLOAD_TYPES.DebitorUpload, UPLOAD_TYPES.HrUpload, UPLOAD_TYPES.ArticleUpload,
            UPLOAD_TYPES.CircuitWireless, UPLOAD_TYPES.CircuitEquiment, UPLOAD_TYPES.CircuitSim, UPLOAD_TYPES.CircuitPlanDetail, UPLOAD_TYPES.CircuitCostAllocation,
            UPLOAD_TYPES.CircuitStatus, UPLOAD_TYPES.InventoryEquipment];

        if(uploadTypeId == UPLOAD_TYPES.InvoiceUpload){
            componentConfig = {
                postUrl: apiEndPoint() + 'external/upload/invoice',
            };
        } 
        else if (uploadTypes.includes(uploadTypeId)){
            componentConfig = {
                postUrl: apiEndPoint() + 'external/adminupload/upload',
            };
        }
        else {
            componentConfig = {
                postUrl: 'no-url',
            };
        }
        

        return componentConfig;
    }

    processQueue = () => {
        this.setState({
            isUploading: true,
            showProgressBar: true,
        });
        this.dropzone.hiddenFileInput.disabled = true;
        this.dropzone.processQueue();
    }

    handleDownload = () => {
        if (this.props.downloadButton) {
            this.props.downloadButton();
        }
    }

    handleDragOver = (event) => {
        if(this.props.disabled == true){
            event.preventDefault();
            event.stopPropagation();
        }
    };

    handleDrop = (event) => {
        if(this.props.disabled == true){
            event.preventDefault();
            event.stopPropagation();
        }
    };


    render() {
        let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InvoiceInvoiceUploadDashboardRE])

        const { djsConfigParams, disabled, onSelect, buttonLabel, templateList, multipleOption } = this.props;
        const djsConfig = this.getDjsConfig();
        const eventHandlers = this.getEventHandlers();       
        const componentConfig = this.getComponentConfig(this.props.uploadTypeId);
        const { isReadAndWrite } = this.state;

        if (this.dropzone) {
            this.dropzone.hiddenFileInput.accept = djsConfigParams.acceptedFiles;
            this.dropzone.hiddenFileInput.disabled = disabled;
        }

        return(
            <div className={`upload-file-container ${isReadAndWrite ? this.props.disabled ? 'disabledUpload' : '' : 'disabledUpload'}`}
                onDragOver={this.handleDragOver}
                onDrop={this.handleDrop}>

                {isReadAndWrite || isReadAndExtractOnly ?
                    (multipleOption ?
                        <CustomDropdownButton onSelect={onSelect} multipleList={multipleOption} buttonIcon="cloud-arrow-down" extractListLabel={buttonLabel} options={templateList} />
                        :
                        <ButtonIcon iconLeft="cloud-arrow-down" iconSize="17px" onClick={this.handleDownload} customClassName={`header-filter-button`} labelName={this.props.buttonLabel} />
                    )
                    
                   
                    :
                 null}    
                <div className="custom-disabled">

                    {isReadAndWrite ?
                    <DropzoneComponent config={componentConfig}
                        eventHandlers={eventHandlers}
                        djsConfig={djsConfig}
                        className={`${isReadAndWrite ? disabled ? 'dz-disabled' : '' : 'dz-disabled'} `}
                    >                      
                        <Icons name="cloud-upload" customClassName="cloud-upload" />
                    </DropzoneComponent>
                    :
                    <CustomDragDrop />
                    }
                </div>
                <div className="dropzone-previews file-details"></div>

                <NotificationModal
                    show={this.state.showErrorNotif}
                    title={MODAL_CUSTOM_TITLE.Error}
                    message={this.state.errorMessage}
                    subMessage={this.state.errorSubMessage}
                    handleModal={this.handleCloseNotif}
                    customClass={'comment-notification-modal notification-footer error-upload-modal'}
                />

                <NotificationModal
                    show={this.state.showProcessNotif}
                    title={MODAL_CUSTOM_TITLE.Notification}
                    message={MODAL_CUSTOM_MESSAGE.upload_notification}
                    handleModal={this.handleCloseNotif}
                    customClass={'comment-notification-modal notification-footer modal-text-bold'}
                />
            </div>		
        )
    }
}

export default DragDropUpload